var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"sidebar",class:_vm.getClasses},[_c('user'),_c('div',{staticClass:"sidebar__section-label"},[_vm._v("Рабочее пространство")]),_c('navigation',{on:{"navigate":_vm.onNavigate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }